export const setExtruderTemperature = (store) => (temperature) => {
  store.extruderTemperature = temperature;
};
